(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ghost-universe"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const buttons = document.querySelectorAll('.ghost-universe-button');

    buttons.forEach((button) => {
      const targetBlockId = button.getAttribute('data-target-block');

      if (button.tagName === 'BUTTON' && targetBlockId) {
        button.addEventListener('click', function() {
          window.revealBlock(targetBlockId);
        });
      }
    });
  });

  window.revealBlock = function(blockId) {
    const banner = document.getElementById('banner');
    const blocks = document.querySelectorAll('.ghost-universe-block');
    
    if (banner) {
      banner.style.display = 'none';
    }
    
    blocks.forEach((block) => {
      block.classList.remove('active');
      if (block.id === blockId) {
        block.classList.add('active');
      }
    });
    
    document.body.style.overflow = 'auto';
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              this.dispatchEvent(new CustomEvent('section:dynamic', { bubbles: true }));
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
